import Vue from 'vue'
export default {
  install(Vue, options) {
    Vue.prototype.replaceAll = function(str, reg, replace) {
      if(str !== '' && str != null && str !== 'null' && typeof str !== "undefined") {
        while(str.indexOf(reg) > -1) {
          str = str.replace(reg, replace);
        }
      }
      return str;
    };
  }
}
